import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useQueryParams } from 'use-query-params'

import { getNLUData } from '../../../api/nluData'
import useApiCall from '../../../api/useApiCall'
import { ReactComponent as PlusCircle } from '../../../assets/icons/add-circle.svg'
import { useNLUDataStore } from '../../../stores/nluDataStore'
import { DashArrayParam } from '../../../utils/useQueryParams'
import LoadingSection from '../../LoadingSection/LoadingSection'
import NotFound from '../../NotFound/NotFound'
import AddExampleTab from '../NLUDataContent/ExamplesHeading/AddExampleTab/AddExampleTab'
import { NLUFilterCategoryEnum } from '../NLUDataContent/ExamplesHeading/NLUFilters/NLUFilters'
import NLUDataExample from '../NLUDataExample/NLUDataExample'

import styles from './nlu-data-examples.module.scss'

interface INLUDataExamples {
    search: string
}

function NLUDataExamples(props: INLUDataExamples) {
    const { search } = props

    const { tab } = useParams()

    const [query] = useQueryParams({
        [NLUFilterCategoryEnum.ENTITIES]: DashArrayParam,
        [NLUFilterCategoryEnum.INTENTS]: DashArrayParam,
    })

    const [{ examples, addingExample }, { setExamples, setAddingExample }] =
        useNLUDataStore()

    const examplesRef = useRef<HTMLDivElement>(null)

    const { t } = useTranslation()

    const [{ loading }] = useApiCall(
        getNLUData,
        setExamples,
        tab || '',
        query || ''
    )

    const [isAnyEntityEditing, setIsAnyEntityEditing] = useState(false)

    return (
        <>
            <div className={styles.nluDataExamples__tableHeading}>
                <div className={styles.nluDataExamples__headingText}>
                    {t('message')}
                    <button
                        className={styles.nluDataExamples__addExampleBtn}
                        onClick={() => setAddingExample(!addingExample)}
                    >
                        <PlusCircle
                            className={styles.nluDataExamples__addExampleIcon}
                        />
                        {t('add_new')}
                    </button>
                </div>
                <div className={styles.nluDataExamples__headingText}>
                    {t('intent')}
                </div>
            </div>
            <div className={styles.nluDataExamples__examples} ref={examplesRef}>
                <div className={styles.nluDataExamples__results}>
                    {examples.length ? (
                        <p>
                            {examples.length} {t('results')}
                        </p>
                    ) : null}
                </div>
                {addingExample && <AddExampleTab />}
                {loading && <LoadingSection />}
                {examples.length ? (
                    examples
                        .filter((example) => {
                            const r = new RegExp(search, 'i')
                            return r.test(example?.text)
                        })
                        .map((example) => (
                            <NLUDataExample
                                key={example._id}
                                example={example}
                                isAnyEntityEditing={isAnyEntityEditing}
                                setIsAnyEntityEditing={setIsAnyEntityEditing}
                                examplesRef={examplesRef}
                            />
                        ))
                ) : (
                    <NotFound title={t('no_nlu')} />
                )}
            </div>
        </>
    )
}

export default NLUDataExamples
